import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { EntryPage } from "@/features/accession/routes/EntryNew";

export const Route = createLazyFileRoute("/_auth/_app/accessions/newv2")({
  component: memo(EntryPage),
});
